class Utilities {
  static secretToken = null;
}

export default Utilities;
